import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/utils/flexible.js';

import 'swiper/dist/css/swiper.min.css';
import 'swiper/dist/js/swiper.min';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import numberChange from '@/utils/numberChange.js';
Vue.directive('number', numberChange);
Vue.use(ElementUI);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  ElementUI,
  render: (h) => h(App),
}).$mount('#app');
